import { FC } from "react";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { DATA_E2E_KEY, IStyledAttributes, parseBoolean } from "@ryde/shared";

const GpsIndicatorCellStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "gps-indicator-cell",
})`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

interface IGpsIndicatorCell {
  value: unknown;
}

export const GpsIndicatorCell: FC<IGpsIndicatorCell> = ({ value }) => {
  const hasGps = parseBoolean(value);

  return (
    <GpsIndicatorCellStyled>
      {hasGps ? <SVG_MUI.GpsActive4SVG /> : <SVG_MUI.GpsInactive4SVG />}
    </GpsIndicatorCellStyled>
  );
};
